import { Card, CardBody, Col } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BorderLeftTitle } from "../../../../Constants/Constants";
import { BorderLeftSubTitle } from "../../../../Data/BonusUi/CreativeCard";

const BorderLeft = () => {
  return (
    <Col md="6" xs="12">
      <Card>
        <CommonCardHeader title={BorderLeftTitle} span={BorderLeftSubTitle} headClass="border-l-primary" />
        <CardBody>
          <UL className="d-flex flex-column gap-1 simple-list">
            <LI>{"Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them."}</LI>
            <LI><strong>{"Visit Us: "}</strong> {"2600 Hollywood Blvd,Florida, United States-33020"}</LI>
            <LI><strong>{"Mail Us: "}</strong>{"contact@us@gmail.com"}</LI>
            <LI><strong>{"Contact Number: "}</strong>{"(954) 357-7760"}</LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderLeft;
